module.exports = __webpack_public_path__ + "img/q_3_sor.0a6f1572.png";